var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-chip',{attrs:{"text-color":_vm.color,"color":"transparent","flat":""}},[_c('span',{staticClass:"text-uppercase text-bold"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }